export default __webpack_public_path__ + "static/media/flamingo5.ecc6f975.jpg";